import { CreateTagForm, TagDto, UpdateTagForm } from "@closerplatform/spinner-openapi";
import { FieldState, FormState } from "formstate";
import { validateNoWhitespace, validateRequired } from "@fidget/common/utils/validatorsFormState";
import {
  ExistingTagFormType,
  ExistingTagFormFields,
  NewTagFormFields,
  NewTagFormType
} from "./types";

export const mapTagToForm = (tag: TagDto): ExistingTagFormType => {
  return new FormState<ExistingTagFormFields>({
    id: new FieldState(tag.id),
    tag: new FieldState(tag.tag),
    enabled: new FieldState(tag.enabled),
    priority: new FieldState(tag.priority),
    required: new FieldState(tag.required),
    showInConversationDetails: new FieldState(tag.showInConversationDetails)
  });
};

export const mapFormToTag = (form: ExistingTagFormType): TagDto => {
  return {
    id: form.$.id.$,
    tag: form.$.tag.$,
    enabled: form.$.enabled.$,
    required: form.$.required.$,
    priority: form.$.priority.$,
    showInConversationDetails: form.$.showInConversationDetails.$
  };
};

export const createNewTagTagForm = (): NewTagFormType => {
  return new FormState<NewTagFormFields>({
    tag: new FieldState("").validators(validateRequired, validateNoWhitespace)
  });
};

export const copyExistingTagForm = (form: ExistingTagFormType): ExistingTagFormType => {
  return new FormState<ExistingTagFormFields>({
    id: new FieldState(form.$.id.$),
    tag: new FieldState(form.$.tag.$),
    enabled: new FieldState(form.$.enabled.$),
    priority: new FieldState(form.$.priority.$),
    required: new FieldState(form.$.required.$),
    showInConversationDetails: new FieldState(form.$.showInConversationDetails.$)
  });
};

export const mapNewFormToCreateForm = (form: NewTagFormType): CreateTagForm => {
  return { tag: form.$.tag.$ };
};

export const mapExistingFormToUpdateForm = (form: ExistingTagFormType): UpdateTagForm => {
  return {
    enabled: form.$.enabled.$,
    priority: form.$.priority.$,
    required: form.$.required.$,
    showInConversationDetails: form.$.showInConversationDetails.$
  };
};
